import { getAcceptLanguageHeader } from '../i18n';

const WIN_BACK_ENDPOINT = '/api/v1/promotions/win-back';

async function request(token, url, options = {}) {
  if (!token) {
    throw new Error('Не найден токен авторизации');
  }

  const response = await fetch(url, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      'Accept-Language': getAcceptLanguageHeader(),
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
  });

  if (!response.ok) {
    const text = await response.text();
    let message = text;
    try {
      const data = JSON.parse(text);
      message = data?.message || data?.error || text;
    } catch {}
    throw new Error(message || `Ошибка запроса (${response.status})`);
  }

  return response.json();
}

export async function fetchWinBackPromotion(token) {
  const payload = await request(token, WIN_BACK_ENDPOINT);
  return payload?.data ?? payload;
}

export async function setWinBackEnabled(token, enabled) {
  const payload = await request(token, `${WIN_BACK_ENDPOINT}/enabled`, {
    method: 'PATCH',
    body: JSON.stringify({ enabled }),
  });
  return payload?.data ?? payload;
}

export async function fetchWinBackRewards(token, page = 1, limit = 25) {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  const payload = await request(token, `${WIN_BACK_ENDPOINT}/rewards?${params.toString()}`);
  return payload?.data ?? payload;
}
